import { Building2, GraduationCap, User, Check, Sparkles } from 'lucide-react';

export default function Pricing() {
  const plans = [
    {
      icon: Building2,
      title: "Corporates",
      subtitle: "Accelerate Hiring, Empower Teams",
      features: [
        "Unlimited candidate screening",
        "Advanced AI interviewing",
        "Custom integration support",
        "Priority customer service",
        "Detailed analytics dashboard"
      ]
    },
    {
      icon: GraduationCap,
      title: "Institutes",
      subtitle: "Equip Students, Elevate Futures",
      features: [
        "Campus placement management",
        "Student interview preparation",
        "Employer connection tools",
        "Performance tracking",
        "Custom branded portal"
      ],
      featured: true
    },
    {
      icon: User,
      title: "Individuals",
      subtitle: "Best Preparation for You",
      features: [
        "AI interview practice",
        "Instant feedback",
        "Skill assessment",
        "Resume optimization",
        "Career guidance"
      ]
    }
  ];

  return (
    <section id="pricing" className="py-32 bg-transparent relative overflow-hidden border-t border-white/5">

      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-20 w-96 h-96 bg-emerald-500 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-teal-500 rounded-full filter blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-500/10 rounded-full mb-6 border border-emerald-500/20">
            <Sparkles className="w-4 h-4 text-emerald-400" />
            <span className="text-sm font-medium text-emerald-400">Flexible Pricing</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Get started with a 30-day trial. Cancel anytime. No credit card required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={index}
              className="relative group flex"
            >
              {plan.featured && (
                <div className="absolute -inset-1 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-3xl blur-lg opacity-75 group-hover:opacity-100 transition-opacity"></div>
              )}
              <div
                className={`relative p-8 rounded-3xl flex flex-col w-full ${
                  plan.featured
                    ? 'bg-gradient-to-br from-emerald-500/20 to-teal-500/20 text-white shadow-2xl border-2 border-emerald-500'
                    : 'glass-dark text-white border border-white/10'
                } transition-all hover:scale-105`}
              >
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-6 ${
                  plan.featured
                    ? 'bg-gradient-to-br from-emerald-500 to-teal-500 shadow-lg shadow-emerald-500/50'
                    : 'bg-gradient-to-br from-emerald-100 to-teal-100'
                }`}>
                  <plan.icon className={`w-8 h-8 ${
                    plan.featured ? 'text-white' : 'text-emerald-600'
                  }`} />
                </div>

                <h3 className="text-2xl font-bold mb-2 text-white">{plan.title}</h3>
                <p className={`mb-8 ${plan.featured ? 'text-slate-200' : 'text-slate-400'}`}>
                  {plan.subtitle}
                </p>

                <ul className="space-y-4 mb-8 flex-grow">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <Check className="w-5 h-5 flex-shrink-0 mt-0.5 text-emerald-400" />
                      <span className={plan.featured ? 'text-white' : 'text-slate-300'}>
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>

                <a href="https://calendar.app.google/SxKx5dUS1G1pBYTFA" target="_blank" rel="noopener noreferrer" className={`block w-full py-4 rounded-xl font-semibold transition-all text-center ${
                  plan.featured
                    ? 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white hover:shadow-2xl hover:shadow-emerald-500/50'
                    : 'bg-white/10 text-white hover:bg-white/20 border border-white/20'
                }`}>
                  Start Pilot
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
